import { MutationTree } from 'vuex'
import { ImagenesSatelitalesState, StoreError } from './types'

export const mutations: MutationTree<ImagenesSatelitalesState> = {
  IMAGENES_SATELITALES_FETCHED (state, payload: ImagenesSatelitalesState) {
    state.error = { state: false }
    state.inicio = payload.inicio
    state.imagenes = payload.imagenes
    state.pasos = payload.pasos
    state.ruta = payload.ruta
    state.fecha_inicio_nieve = payload.fecha_inicio_nieve
    state.centro = payload.centro
    state.latlong = payload.latlong
    state.delta = payload.delta
    state.etiquetas = payload.etiquetas
    state.timeline_config = payload.timeline_config
    state.icon = payload.icon
  },
  IMAGENES_SATELITALES_ERROR (state, payload: StoreError) {
    state.error = payload
  }
}
